import {Component, Input} from '@angular/core';
import {DateHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {WeitereAngabenAnteilseigner, WeitereAngabenGesellschaftern} from '@nachdigal';

@Component({
  selector: 'common-ui-person-extended-weitere-angaben',
  templateUrl: './person-extended-weitere-angaben.component.html'
})
export class PersonExtendedWeitereAngabenComponent extends FormBaseComponent<WeitereAngabenAnteilseigner | WeitereAngabenGesellschaftern> {

  @Input()
  public enableWeitereAngabenJuristischePerson: boolean;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      geburtsdatum: [
        this.data.geburtsdatum,
        [
          this.validatorService.required(),
          this.validatorService.date(),
          this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.geburtsdatum),
            this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
        ]],
      beruflicheTaetigkeit: [
        this.data.beruflicheTaetigkeit, [
          this.validatorService.maxLength(50)
        ]
      ],
      identifikationsnummer: [
        this.data.identifikationsnummer,
        [
          this.validatorService.pattern('^[0-9]{11}$',
            this.translateService.instant('COMMON_UI.VALIDATION.STEUERIDENTIFIKATIONSNUMMER_INVALID_PATTERN'))
        ]],
      artDesBetriebes: [
        this.data.artDesBetriebes, [
          this.validatorService.maxLength(100)
        ]]
    });

  }
}
